var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DirectionalArrows component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDirectionalArrows extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.3802 1.17C12.3802 1.17 12.4202 1.2 12.4302 1.22L15.5502 4.34C15.8402 4.63 15.8402 5.11 15.5502 5.4C15.2602 5.69 14.7802 5.69 14.4902 5.4L12.6502 3.56V11.14H20.2302L18.3902 9.3C18.1002 9.01 18.1002 8.53 18.3902 8.24C18.6802 7.95 19.1602 7.95 19.4502 8.24L22.5702 11.36C22.6502 11.44 22.7002 11.52 22.7402 11.62C22.7702 11.71 22.7902 11.8 22.7902 11.89C22.7902 12 22.7702 12.11 22.7202 12.2C22.6902 12.26 22.6602 12.31 22.6202 12.36C22.6002 12.38 22.5802 12.4 22.5602 12.42L19.4402 15.54C19.1502 15.83 18.6702 15.83 18.3802 15.54C18.0902 15.25 18.0902 14.77 18.3802 14.48L20.2202 12.64H12.6402V20.22L14.4802 18.38C14.7702 18.09 15.2502 18.09 15.5402 18.38C15.8302 18.67 15.8302 19.15 15.5402 19.44L12.4202 22.56C12.4202 22.56 12.3802 22.6 12.3602 22.62C12.3102 22.66 12.2602 22.69 12.2002 22.72C12.1002 22.76 12.0002 22.79 11.8902 22.79C11.7902 22.79 11.7002 22.77 11.6202 22.74C11.5302 22.7 11.4402 22.65 11.3602 22.57L8.24023 19.45C7.95023 19.16 7.95023 18.68 8.24023 18.39C8.53023 18.1 9.01023 18.1 9.30023 18.39L11.1402 20.23V12.65H3.56023L5.40023 14.49C5.69023 14.78 5.69023 15.26 5.40023 15.55C5.11023 15.84 4.63023 15.84 4.34023 15.55L1.22023 12.43C1.22023 12.43 1.19023 12.39 1.17023 12.38C1.13023 12.33 1.09023 12.27 1.06023 12.21C1.02023 12.12 0.990234 12.01 0.990234 11.9H1.00023C1.00023 11.8 1.02023 11.72 1.05023 11.63C1.09023 11.53 1.14023 11.44 1.22023 11.37L4.34023 8.25C4.63023 7.96 5.11023 7.96 5.40023 8.25C5.69023 8.54 5.69023 9.02 5.40023 9.31L3.56023 11.15H11.1402V3.56L9.30023 5.4C9.01023 5.69 8.53023 5.69 8.24023 5.4C7.95023 5.11 7.95023 4.63 8.24023 4.34L11.3602 1.22C11.4402 1.14 11.5302 1.09 11.6202 1.05C11.7102 1.02 11.8002 1 11.8902 1C12.0002 1 12.1002 1.02 12.2002 1.07C12.2602 1.1 12.3202 1.13 12.3702 1.18L12.3802 1.17Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDirectionalArrows.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDirectionalArrows.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDirectionalArrows.prototype, "size", void 0);
if (customElements.get('cat-icon-directional-arrows') === undefined) {
    customElements.define('cat-icon-directional-arrows', BlocksIconDirectionalArrows);
}
